import type { RenderProps } from "../../common/types";

function renderFieldValue(value: unknown) {
  if (value === null || value === undefined || value === "") {
    return <span className="text-on-disabled-quiet">Vacío</span>;
  }
  return typeof value === "string" ? value.toString() : "-";
}

export default function interoperabilityRenderer({ fieldArr }: RenderProps) {
  const uniqueFieldsCount = new Set(fieldArr?.map((f) => f.label)).size;
  const lastFields = fieldArr?.slice(-uniqueFieldsCount) ?? [];
  return (
    <div className="flex flex-col gap-2">
      {lastFields.map((filledField, index) => (
        <div key={`${filledField.id}-${index}`} className="flex flex-col">
          <p className="text-xs text-info font-semibold">
            {filledField.label}:
          </p>
          <p className="break-normal whitespace-pre-wrap text-size-body">
            {renderFieldValue(filledField.value)}
          </p>
        </div>
      ))}
    </div>
  );
}
